import { useRef } from "react";
import {
  ButtonContainer,
  ButtonSecondary,
  Container,
  LoginCard,
  LoginInput,
} from "./login.styled";
import finger from "../../assets/fingerprint.svg";
import { ButtonPrimary } from "@components";
import User from "../../stores/UserStore";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Error from "../../components/error";
import ErrorSubscription from "../../stores/ErrorSubscriptionStore";
import { Spinner } from "../../components/SpinnerRaw/SpinnerRaw";
import CONSTANTS from "../../utils/constants";
import generalStore from "../../stores/GeneralStore";
import { callRemoteMethod } from "src/utils/WebserviceHandler";
import axios from "axios";
import General from "../../stores/GeneralStore";
import { observer } from "mobx-react";
import ReCAPTCHA from "react-google-recaptcha";
import { NotifyError } from "../../utils/ShowError";
import { gridColumnsTotalWidthSelector } from "@mui/x-data-grid";
import ProfileOTP from "../../components/Profile/ProfileOTP";
import MFA from "../../components/MFA/MFA";
import { fetchDeviceInfo } from "../../utils/authHelper";
import { platform } from "node:os";

const Login = () => {
  const loginErrorId = "loginError";
  const [error, setError] = useState<any>({ username: "", password: "" });
  const [data, setData] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const passwordRef = useRef<HTMLInputElement | null>(null);
  const userNmaeRef = useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();
  const [loginAttempts, setLoginAttempts] = useState(0); // Track login attempts
  const [isCaptchaVerified, setIsCaptchaVerified] = useState<boolean | null>(null); // Track reCAPTCHA status

  const [email, setEmail] = useState<any>();
  const [mobile, setMobile] = useState<any>();
  const [enableMobilebleField, setEnableMobilebleField] = useState();
  const [isMobileEdit, setIsMobileEdit] = useState(false);
  const [isMFARequired, setIsMFARequired] = useState(false);
  const [showClassicPopup, setShowClassicPopup] = useState(true);
  const [showCaptcha, setShowCaptcha] = useState(false); 
  const [otpModalOpen, setOTPModalOpen] = useState<boolean>(false);
  //let user = new User();
  const MAX_LOGIN_ATTEMPTS = 3; // Set the maximum number of login attempts
  const key: string = process.env.REACT_APP_RECAPTCHA_SITE_KEY || "";
  const createUaePassAuthUrl = (uaePassconfiguration: any) => {
    let currentLang = localStorage.getItem("settingUplanguage");
    let uaePassEndpoint = uaePassconfiguration.uaePassEndPoint;
    let redirectURI = uaePassconfiguration.redirectURL;
    let clientID = uaePassconfiguration.clientID;
    let state = uaePassconfiguration.state;
    let scope = uaePassconfiguration.scope;
    var acrValues = uaePassconfiguration.acrValuesWeb;
    let responseType = uaePassconfiguration.responseType;
    let uaePassAuthURL =
      uaePassEndpoint +
      "redirect_uri=" +
      redirectURI +
      "&client_id=" +
      clientID +
      "&response_type=" +
      responseType +
      "&state=" +
      state +
      "&scope=" +
      scope +
      "&acr_values=" +
      acrValues +
      "&ui_locales=" +
      (currentLang && currentLang != "-" ? currentLang.toLowerCase() : "en-us");
    //https://stg-id.uaepass.ae/idshub/authorize?redirect_uri=http://213.42.234.23:8902/Home/redirect&client_id=sandbox_stage&response_type=code&state=ShNP22hyl1jUU2RGjTRkpg==&scope=urn:uae:digitalid:profile:general&acr_values=urn:safelayer:tws:policies:authentication:level:low&ui_locales=en-us
    return uaePassAuthURL;
  };
  const handleUAEPassRedirection = async () => {
    await User?.uaeGetConfig();
    const res = User?.uaePassConfigDetails;
    const uaePassAuthURL = createUaePassAuthUrl(res);
    window.open(uaePassAuthURL, "_self");
  };
  const ColorAss = General?.ColorAss;
  const contrast = General?.contrast;

  const prepareUAEData = async () => {
    const uaePassUserInfo = User.uaePassDetails.uuId;
    // console.log(uaePassUserInfo);
    if (User.uaePassDetails.uuId) {
      handleUAESubmit();
      return;
    }
  };

  const redirectOnLogin = async (personId?: string) => {
    User.setUserInfo();
    User.persistLoginInfo();
    const redirectPath = localStorage.getItem("redirectPath") || "/dashboard";
    localStorage.removeItem("redirectPath");
    navigate(redirectPath);
  };

  /**
   * Method to handle user login
   * @returns
   */
  const handleSubmit = async () => {
    if (loginAttempts >= MAX_LOGIN_ATTEMPTS) {
      setIsCaptchaVerified(false);
    }
    if (loginAttempts >= MAX_LOGIN_ATTEMPTS && !isCaptchaVerified) {
      setError("Please verify the reCAPTCHA.");
      NotifyError("Please verify the reCAPTCHA.");
      return;
    }
    const password = passwordRef?.current?.value;
    const username = userNmaeRef?.current?.value;
    const { ipAddress, deviceId } = await fetchDeviceInfo();

    const data = {
      password,
      username,
      recaptchaToken,
      platform: "web",
      sessionData: {
        deviceId: deviceId,
        ipAddress: ipAddress,
      },
    };
    if (!username) {
      setError({ username: "email is required" });
    } else if (!password) {
      setError({ password: "password is required" });
    } else {
      setIsLoading(true);
      setShowCaptcha(false);
      await User.login({
        data,
        errorId: loginErrorId,
      });
      setIsLoading(false);

      console.log(User.initialInfo);
      const personId = User.initialInfo.personId as string;
      console.log(User.initialInfo.maskedEmail);
      console.log(User.initialInfo.maskedMobileNumber);
      console.log(User.initialInfo.isMfaRequired);
      const loginError = User.loginError;
      if(loginError && loginError === "RecaptchaError"){
        setIsCaptchaVerified(false);
        setShowCaptcha(true);
      }
      if (personId) {
        setLoginAttempts(0);
        localStorage.removeItem("redirectFrom");
        console.log(User.initialInfo.isMfaRequired);
        if (!User.initialInfo.isMfaRequired as boolean) {
          User.persistLoginInfo();
          User.getFavourites();
          User.getProfile(personId);
          redirectOnLogin();
        } else {
          setIsMFARequired(true);
        }
      } else {
        setLoginAttempts((prevAttempts) => prevAttempts + 1);
      }
    }
  };

  const handleUAESubmit = async () => {
    let data = {
      uuid: User.uaePassDetails.uuId ? User.uaePassDetails.uuId : null,
      emiratesId: User.uaePassDetails.emiratesId
        ? User.uaePassDetails.emiratesId
        : null,
      isUaePassEnabled: true,
    };

    await User.login({
      data,
      errorId: loginErrorId,
    });

    if (User.info.personId) {
      console.log("*** - UAE - User.info.personId:", User.info);
      User.getProfile(User.info.personId as string);
      User.getFavourites();
      navigate("/dashboard");
    }

    // if (response && response.status === 200 && !response.data.result.status) {
    //   //TODO: Continue with UAE Pass Registration

    // }
  };

  const handleChange = (e: any) => {
    let value = e.target.value;
    setData({ ...data, [e.target.name]: value });
    setError({ username: "", password: "" });
  };

  useEffect(() => {
    General?.handleBackClick();
    ErrorSubscription.unSubscribeAll();

    if (User.info.personId) {
      console.log("already logged in");
      User.getFavourites();
      navigate("/dashboard");
    }

    prepareUAEData();
    const handleKeyPress = (e: any) => {
      if (e.key === "Enter") {
        e.preventDefault();
        handleSubmit();
      }
    };

    document.addEventListener("keypress", handleKeyPress);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener("keypress", handleKeyPress);
    };
  }, []);
  const handleSwitchToClassic = () => {
    var expiryDays = 7;
    var date = new Date();
    date.setTime(date.getTime() + expiryDays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + date.toUTCString();
    document.cookie =
      "useNewLogin=false; " +
      expires +
      "; path=/; domain=.ajmansewerage.ae; SameSite=Lax;";
    window.location.href = `${CONSTANTS?.URL?.CUSTOMER_PORTAL_OLD}`;
    User.logout();
  };

  const [recaptchaToken, setRecapatchaToken] = useState<string | null>("");
  return (
    <Container>
      {isMFARequired && (
        <MFA
          mobile={User.initialInfo.maskedMobileNumber}
          personID={User.initialInfo.personId}
          email={User.initialInfo.maskedEmail}
          onClose={() => {
            setOTPModalOpen(false);
          }}
          redirectOnLogin={redirectOnLogin}
        />
      )}
      {!isMFARequired && (
        <LoginCard
          style={{
            backgroundColor: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "",
            color: contrast?.contrastColor
              ? contrast?.contrastColor
              : "#101e8e",
            padding: General?.isLargeScreen ? "40px 40px 35px" : "",
            width: General?.isLargeScreen ? "" : "95vw",
          }}
        >
          <h1
            style={{
              alignSelf: General?.isLargeScreen ? "center" : "",
              fontWeight: "500",
              fontSize: General?.isLargeScreen
                ? `${2.5 * General.accessibility.fontSize}rem`
                : `${1.7 * General.accessibility.fontSize}rem`,
              marginTop: General?.isLargeScreen ? "" : "1rem",
            }}
            className={General?.textClass}
          >
            {General?.codeLabels["cm_login_tenant"]?.label !== undefined
              ? General?.codeLabels["cm_login_tenant"]?.label
              : "Login as a Tenant / Owner"}
          </h1>
          <p
            className={General?.textClass}
            style={{ fontSize: `${0.8 * General.accessibility.fontSize}rem` }}
          >
            {General?.codeLabels[
              "cm_login_to_manage_your_ajman_sewerage_account"
            ]?.label !== undefined
              ? General?.codeLabels[
                  "cm_login_to_manage_your_ajman_sewerage_account"
                ]?.label
              : "Login To manage your Ajman Sewerage account"}
          </p>
          <Error id={loginErrorId} />

          <label>
            <b
              className={General?.textClass}
              style={{ fontSize: `${0.8 * General.accessibility.fontSize}rem` }}
            >
              {General?.codeLabels["cm_username"]?.label !== undefined
                ? General?.codeLabels["cm_username"]?.label
                : "Username"}{" "}
              *
            </b>
          </label>
          <LoginInput
            className={General?.textClass}
            ref={userNmaeRef}
            name="username"
            onBlur={handleChange}
          />
          {error?.username && (
            <p style={{ color: "red" }}>
              {General?.codeLabels["cm_mob_userrqrd"]?.label
                ? General?.codeLabels["cm_mob_userrqrd"]?.label
                : "Username is mandatory"}
            </p>
          )}
          <p
            onClick={() => navigate("/forgot-username")}
            style={{
              alignSelf: "flex-end",
              cursor: "pointer",
              fontSize: `${0.8 * General.accessibility.fontSize}rem`,
              marginTop: "10px",
            }}
            className={General?.textClass}
          >
            {General?.codeLabels["cm_forgotun"]?.label !== undefined
              ? General?.codeLabels["cm_forgotun"]?.label
              : "Forgot Username"}
          </p>
          <label>
            <b
              className={General?.textClass}
              style={{ fontSize: `${0.8 * General.accessibility.fontSize}rem` }}
            >
              {General?.codeLabels["cm_password"]?.label !== undefined
                ? General?.codeLabels["cm_password"]?.label
                : "Password"}
            </b>
          </label>
          <LoginInput
            className={General?.textClass}
            ref={passwordRef}
            type="password"
            name="password"
            onBlur={handleChange}
          />
          {error?.password && (
            <p style={{ color: "red" }}>
              {General?.codeLabels["cm_mob_passrqrd"]?.label
                ? General?.codeLabels["cm_mob_passrqrd"]?.label
                : "Password is mandatory"}
            </p>
          )}
          <p
            onClick={() => navigate("/forgot-password")}
            style={{
              alignSelf: "flex-end",
              cursor: "pointer",
              fontSize: `${0.8 * General.accessibility.fontSize}rem`,
              marginTop: "10px",
            }}
            className={General?.textClass}
          >
            {General?.codeLabels["cm_forgot_username"]?.label !== undefined
              ? General?.codeLabels["cm_forgot_username"]?.label
              : "Forgot Password?"}
          </p>
          {}
          {loginAttempts >= MAX_LOGIN_ATTEMPTS ||  showCaptcha ? (
            <ReCAPTCHA
              sitekey={key}
              onChange={(token) => {
                setRecapatchaToken(token);
                setIsCaptchaVerified(true);
              }}
              onExpired={() => setIsCaptchaVerified(false)}
              style={{
                marginBottom: "20px",
              }}
              className={General?.textClass}
            />
          ) : null}
          <ButtonContainer>
            {isLoading ? (
              <Spinner />
            ) : (
              <ButtonPrimary
                label={
                  General?.codeLabels["cm_login"]?.label
                    ? General?.codeLabels["cm_login"]?.label
                    : "Login"
                }
                styles={{
                  height: "3rem",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  zIndex: 0,
                  background: General.contrast.contrastColor
                    ? General.contrast.contrastColor === "yellow"
                      ? "#FFFF00"
                      : General.contrast.contrastColor === "lime"
                      ? "#00FF00"
                      : ""
                    : General?.ColorAss
                    ? General?.ColorAss
                    : "",
                  color: General.contrast.contrastColor
                    ? General.contrast.contrastColor === "yellow"
                      ? "#0000FF"
                      : General.contrast.contrastColor === "lime"
                      ? "#000"
                      : ""
                    : General?.ColorAss
                    ? ""
                    : General?.ColorAss,
                }}
                onClick={handleSubmit}
              />
            )}
            <p
              style={{
                fontSize: `${0.8 * General.accessibility.fontSize}rem`,
                textTransform: "capitalize",
                margin: "10px 0px",
              }}
              className={General?.textClass}
            >
              {/* {General?.codeLabels["cm_mob_or"]?.label !== undefined
              ? General?.codeLabels["cm_mob_or"]?.label
              : "OR"}{" "} */}
              {General?.codeLabels["cm_mob_or"]?.label
                ? General?.codeLabels["cm_mob_or"]?.label.toUpperCase()
                : "OR"}
            </p>
            <ButtonSecondary
              className={General?.colorClass}
              style={{
                zIndex: 0,
                width: "100%",
                display: "flex",
                justifyContent: "center",
                background: General.contrast.contrastColor
                  ? General.contrast.contrastColor === "yellow"
                    ? "#FFFF00"
                    : General.contrast.contrastColor === "lime"
                    ? "#00FF00"
                    : ""
                  : "",
                color:
                  General.contrast.contrastColor === "yellow"
                    ? "#0000FF"
                    : General.contrast.contrastColor === "lime"
                    ? "#000"
                    : "",
              }}
              onClick={handleUAEPassRedirection}
              children={
                <>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                      width: "100%",
                      justifyContent: "center",
                    }}
                  >
                    <img src={finger} alt="" />
                    <span
                      style={{
                        fontSize: General?.isLargeScreen
                          ? `${General.accessibility.fontSize}rem`
                          : `${0.85 * General.accessibility.fontSize}rem`,
                      }}
                    >
                      {General?.codeLabels["cm_signin_with_uae"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_signin_with_uae"]?.label
                        : "Sign in with UAE PASS"}
                    </span>
                  </div>
                </>
              }
            />
          </ButtonContainer>
          <p
            style={{
              fontSize: `${0.8 * General.accessibility.fontSize}rem`,
              margin: "20px 0px",
            }}
            className={General?.textClass}
          >
            {General?.codeLabels["cm_nocapplyoutsidetext"]?.label !== undefined
              ? General?.codeLabels["cm_nocapplyoutsidetext"]?.label
              : "Do you want to apply for NOC outside network?"}

            <span style={{ textDecoration: "underline" }}>
              <Link
                to="/noc-apply-outside"
                state={{ login: true }}
                className={General?.textClass}
                style={{
                  visibility: "visible",
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#101e8e",
                }}
              >
                {General?.codeLabels["cm_refnd_click_here"]?.label !== undefined
                  ? General?.codeLabels["cm_refnd_click_here"]?.label
                  : "Click here."}
              </Link>
            </span>
          </p>
          <p
            style={{
              fontWeight: "900",
              cursor: "pointer",
              fontSize: `${0.875 * General.accessibility.fontSize}rem`,
              color: contrast?.contrastColor
                ? contrast?.contrastColor
                : "#101e8e",
            }}
            className={General?.textClass}
          >
            {General?.codeLabels["cm_new_user"]?.label !== undefined
              ? General?.codeLabels["cm_new_user"]?.label
              : "New User?"}
            <span
              onClick={() => {
                localStorage.removeItem("redirectFrom");
                General?.handleBackClick();
                navigate("/movein-registration");
              }}
            >
              <Link
                to="#"
                style={{
                  visibility: "visible",
                  color: contrast?.contrastColor
                    ? contrast?.contrastColor
                    : "#101e8e",
                }}
                className={General?.textClass}
              >
                {" "}
                {General?.codeLabels["cm_create_new_account"]?.label !==
                undefined
                  ? General?.codeLabels["cm_create_new_account"]?.label
                  : "Create New Account here"}
              </Link>
            </span>
          </p>
        </LoginCard>
      )}
      {/* {showClassicPopup && (
        <div
          className="classic-popup"
          style={{
            position: "fixed",
            bottom: 18,
            right: 90,
            zIndex: 9999,
            background: "#fff",
            borderRadius: 10,
            padding: "14px 16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            minWidth: 160,
            boxShadow: "0 2px 8px rgba(16,30,142,0.10)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              position: "relative",
            }}
          >
            <span
              style={{
                fontWeight: 500,
                color: "#101E8E",
                fontSize: "0.95rem",
                flex: 1,
              }}
            >
              Switch to classic site
            </span>
            <button
              aria-label="Close"
              onClick={() => {
                setShowClassicPopup(false);
              }}
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: 18,
                color: "#101E8E",
                padding: 0,
                lineHeight: 1,
                marginLeft: 8,
              }}
            >
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M4 4l10 10M14 4L4 14"
                  stroke="#101E8E"
                  strokeWidth="2"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
          <button
            style={{
              background: "linear-gradient(90deg, #101E8E 60%, #4f5bd5 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 5,
              padding: "6px 14px",
              fontSize: "0.95rem",
              cursor: "pointer",
              fontWeight: 500,
              boxShadow: "0 2px 8px rgba(16,30,142,0.10)",
              display: "flex",
              alignItems: "center",
              marginTop: 8,
            }}
            onClick={() => {
              handleSwitchToClassic();
            }}
          >
            Click Here
            <span className="arrow-icon" style={{ marginLeft: 6 }}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path
                  d="M7 5l5 5-5 5"
                  stroke="#fff"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>
        </div>
      )} */}
    </Container>
  );
};

export default observer(Login);
